import { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import git2 from '../assets/img/git2.png';
import lomgo1 from '../assets/img/lomgo1.png';
import medium3 from '../assets/img/medium3.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
 
export const NavBar=() =>{
  const[activeLink, setActiveLink]= useState('home');
  const[scrolled, setScrolled]=useState(false)
  useEffect(()=>{ 
    const onScroll= ()=> {
      if(window.scrollY>50){
        setScrolled(true)
      }
      else{
        setScrolled(false)
      }
    }
    window.addEventListener("scroll",onScroll)

    return()=> window.removeEventListener("scroll",onScroll)
  },[])
  const onUpdateActiveLink=(value)=>{
    setActiveLink(value);
  }
  return(
    <Navbar expand="lg" className={scrolled? "scrolled":""}>
<Container>
  <Navbar.Brand href="#home">
    <img src={lomgo1} alt="Logo"/>
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="basic-navbar-nav">
    <span className="navbar-toggler-nav"></span>
  </Navbar.Toggle>
  <Navbar.Collapse id="basic-navbar-nav">
    <Nav className="me-auto">
      <Nav.Link href="#home" className={activeLink==='home'?'active navbar-link':'navbar-link'}onClick={()=>onUpdateActiveLink('home')}>Home</Nav.Link>
      <Nav.Link href="#skills" className={activeLink==='skills'?'active navbar-link':'navbar-link'}onClick={()=>onUpdateActiveLink('skills')}>Skills</Nav.Link>
      <Nav.Link href="#projects" className={activeLink==='projects'?'active navbar-link':'navbar-link'}onClick={()=>onUpdateActiveLink('projects')}>Projects</Nav.Link>
      </Nav>
      <span className="navbar-test">
        <div className="social-icon">
          <a href="https://www.linkedin.com/in/abhishek-tyagi-6ab59a225/" target="_blank"><img src={navIcon1} alt="Linked In"></img></a>
          <a href="https://github.com/atyagiabhi210" target="_blank"><img src={git2} alt="Git Hub"></img></a>
          <a href="https://medium.com/@atyagiabhi210" target="_blank"><img src={medium3} alt="Medium"></img></a>
        </div>
       
      </span>
  </Navbar.Collapse>
</Container>
</Navbar>
  )
}